import { constructionData } from './constructionData';
import { laboratoryData } from './laboratoryData';
import { productionData } from './productionData';

export default {
   'dla-firm-produkcyjnych': productionData,
   'dla-laboratoriow': laboratoryData,
   'dla-firm-budowlanych': constructionData,
};
